import React, { useState } from 'react'
import LosLogo from '../../../../images/rewampimages/LOS.svg'
import LmsLogo from '../../../../images/rewampimages/LMS.svg'
import FinanceLogo from '../../../../images/rewampimages/finance.svg'
import electricCar from '../../../../images/rewampimages/electricCar.png'
import MarketingLogo from '../../../../images/rewampimages/marketing.svg'
import CollectionLogo from '../../../../images/rewampimages/Collection.svg'
import AccessmanagementLogo from '../../../../images/rewampimages/accessmanagement.svg'
import DashboardLogo from '../../../../images/rewampimages/dashboardreport.svg'
import ToolsLogo from '../../../../images/rewampimages/tools.svg'
import NbfcLogo from '../../../../images/rewampimages/nbfc.svg'
import { ROLE, tenant } from '../../../../utils/Constant'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ViewStreamIcon from '@mui/icons-material/ViewStream';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import CircleIcon from '@mui/icons-material/Circle';
import { GenerateReportcheck, EmailNotcheckFn } from '../../../../utils/CustomEmailCheck'
import { ABHICASH_LIKE, CHECK_COMPANY_TENANT, Company_DATA, CREDFIN_LIKE, DREAM_SUPPORTER_LIKE, DREAM_SUPPORTER_ONLY } from '../../../../layouts/MainTenantconfig'
// const Landingpage = ({ pageViewHandler, admin }) => {
//     const [lmsSubTab, setlmsTab] = useState(false)
//     const subHandleTab = (first, second) => {

//         if (second === 'lms' && first === 'bulkOps') {
//             setlmsTab(!lmsSubTab)
//         }
//     }
class Landingpage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            lmsSubTab: false,
            generateReportState: true,
            nbfcTabs: false,
            productTab: false,
            policyTab: false,
            policyTabTech: false,
            lendingProduct: false,
            targetTab: false,
            paymentTabs: false,
            TallyReportsTab: false,
        }
    }
    componentDidMount() {
        const { admin } = this.props
        if (admin.emailId !== undefined && admin.role != "superuser" && EmailNotcheckFn(admin.emailId, GenerateReportcheck)) {
            var today = new Date().getHours();
            if (today > 19) {
                console.log(today, 'Hour')
            }
            if (today < 9) {
                console.log(today, 'Hours')
            }
            if (today > 9 && today < 19) {
                console.log(today)
                this.setState({ generateReportState: false })
            }
        }
    }





    subHandleTab(e, first, second) {
        e.stopPropagation()
        if (second === 'lms' && first === 'bulkOps') {
            // setlmsTab(!lmsSubTab)
            this.setState({ lmsSubTab: !this.state.lmsSubTab })
        }
    }
    subHandleTabproduct(e, first, second) {
        e.stopPropagation()

        this.setState({ productTab: !this.state.productTab })

    }
    nbfcTabsHandle() {
        this.setState({ nbfcTabs: !this.state.nbfcTabs })


    }
    subHandleTabPolicy(e) {
        e.stopPropagation()

        this.setState({ policyTab: !this.state.policyTab })
    }
    subHandleTech(e) {

        e.stopPropagation()

        this.setState({ policyTabTech: !this.state.policyTabTech })
    }
    subHandleTechLending(e) {

        e.stopPropagation()

        this.setState({ lendingProduct: !this.state.lendingProduct })
    }
    subHandleTabTarget(e) {
        e.stopPropagation()

        this.setState({ targetTab: !this.state.targetTab })
    }
    HandleTallyReportsTab(e) {
        e.stopPropagation()

        this.setState({ TallyReportsTab: !this.state.TallyReportsTab })
    }
    paymentSection(e) {
        e.stopPropagation()

        this.setState({ paymentTabs: !this.state.paymentTabs })
    }
    render() {
        const { admin, pageViewHandler } = this.props
        return (
            <>
                {admin && admin.rolelist !== undefined ?
                    <div className='container-fluid blue-scroll'>
                        <div className='row'>
                            {console.log(window.innerWidth)}
                            {admin.rolelist != undefined && (admin.rolelist.indexOf(ROLE.LOAN_APPROVAL_LEADS) >= 0 || admin.rolelist.indexOf(ROLE.APPLICATION_STATUS) >= 0 || admin.rolelist.indexOf(ROLE.LEAD_MANAGEMENT) >= 0 || admin.rolelist.indexOf(ROLE.Gift_Card_Leads) >= 0 || admin.rolelist.indexOf(ROLE.LM_Customer_Service_Dashboard) >= 0 || admin.rolelist.indexOf(ROLE.LM_Credit_Dashboard) >= 0 || admin.rolelist.indexOf(ROLE.LM_Legal_Dashboard) >= 0) ?
                                <div className='col-sm-3 col-xs-12'>
                                    <div className='landing-cards' onClick={() => this.props.mainMenuHandler('LOS')}>
                                        <div className='landing-head' style={{ background: '#e8ffea', borderTopLeftRadius: '5px', borderTopRightRadius: '5px' }}>
                                            <img style={{ width: '24px' }} src={LosLogo} />&nbsp;LOS
                                        </div>

                                        <ul className='landing-inner' style={{ listStyle: 'none' }}>
                                            <>
                                                {admin.rolelist.indexOf(ROLE.LOAN_APPROVAL_LEADS) >= 0 && (
                                                    <li
                                                        style={{ marginTop: '15px' }}
                                                        id='leadMainPage'
                                                        onClick={(e) => pageViewHandler(e, 'leadMainPage')}
                                                    >
                                                        <ViewStreamIcon style={{ width: '13px', marginBottom: '-1px' }} /> &nbsp;  Loan Applications
                                                    </li>
                                                )}
                                                {admin.rolelist.indexOf(ROLE.APPLICATION_STATUS) >= 0 && (
                                                    <li
                                                        style={{ marginTop: '15px' }}
                                                        id='AppStatus'
                                                        onClick={(e) => pageViewHandler(e, 'AppStatus')}
                                                    >
                                                        <ViewStreamIcon style={{ width: '13px', marginBottom: '-1px' }} /> &nbsp; All Application
                                                    </li>
                                                )}
                                               
                                                {admin.rolelist.indexOf(ROLE.LEAD_MANAGEMENT) >= 0 && (
                                                    <li
                                                        style={{ marginTop: '15px' }}
                                                        id='leadManagement'
                                                        onClick={(e) => pageViewHandler(e, 'leadManagementNew')}
                                                    >
                                                        <ViewStreamIcon style={{ width: '13px', marginBottom: '-1px' }} /> &nbsp; Lead Management
                                                    </li>
                                                )}

                                              

                                                <div style={{ marginTop: '15px', cursor: 'pointer' }}

                                                    onClick={e => pageViewHandler(e, 'RmCommunity')}
                                                >
                                                    <ViewStreamIcon style={{ width: '13px', marginBottom: '-1px' }} /> &nbsp; RM
                                                </div>
                                                <div style={{ marginTop: '15px', cursor: 'pointer' }}

                                                    onClick={e => pageViewHandler(e, 'RmCommunityDashboard')}
                                                >
                                                    <ViewStreamIcon style={{ width: '13px', marginBottom: '-1px' }} /> &nbsp; RM Dashboard
                                                </div>

                                               
                                            </>

                                        </ul>
                                    </div>
                                </div>

                                : ""}
                            {admin.rolelist != undefined && admin.rolelist.length > 0 ?
                                (admin.rolelist.indexOf(ROLE.Disbursed_Leads) >= 0 || admin.rolelist.indexOf(ROLE.Incoming_Leads) >= 0 || admin.rolelist.indexOf(ROLE.Nach_Registration) >= 0 || admin.rolelist.indexOf(ROLE.Bulk_Nach_Bounce) >= 0 || admin.rolelist.indexOf(ROLE.Initiate_Bulk_Payment) >= 0 || admin.rolelist.indexOf(ROLE.Bulk_Paid) >= 0 || admin.rolelist.indexOf(ROLE.Bulk_Nach_Status_Update) >= 0) ?
                                    <div className='col-sm-3 col-xs-12'>
                                        <div className='landing-cards' onClick={() => this.props.mainMenuHandler('LMS')}>
                                            <div className='landing-head' style={{ background: '#fffcce', borderTopLeftRadius: '5px', borderTopRightRadius: '5px' }}>
                                                <img style={{ width: '24px' }} src={LmsLogo} />&nbsp;LMS
                                            </div>
                                            <ul className='landing-inner' style={{ listStyle: 'none' }}>
                                                <>
                                                    {admin.rolelist.indexOf(ROLE.Disbursed_Leads) >= 0 && (
                                                        <li style={{ marginTop: '15px' }} onClick={(e) => pageViewHandler(e, 'recoveryDisburse')}>
                                                            <ViewStreamIcon style={{ width: '13px', marginBottom: '-1px' }} /> &nbsp; Disbursed Leads
                                                        </li>
                                                    )}
                                                    {admin.rolelist.indexOf(ROLE.Incoming_Leads) >= 0 && (
                                                        <li style={{ marginTop: '15px' }} onClick={(e) => pageViewHandler(e, 'recoveryIncoming')}>
                                                            <ViewStreamIcon style={{ width: '13px', marginBottom: '-1px' }} /> &nbsp; Incoming Payments
                                                        </li>
                                                    )}
                                                  
                                                    {admin.emailId === "SuperUser" && (
                                                        <li style={{ marginTop: '15px' }} onClick={(e) => pageViewHandler(e, 'nachManagmentDashboard')}>
                                                            <ViewStreamIcon style={{ width: '13px', marginBottom: '-1px' }} /> &nbsp; NACH Management
                                                        </li>
                                                    )}

                                                    {(admin.rolelist.indexOf(ROLE.Bulk_Nach_Bounce) >= 0 ||
                                                        admin.rolelist.indexOf(ROLE.Initiate_Bulk_Payment) >= 0 ||
                                                        admin.rolelist.indexOf(ROLE.Bulk_Paid) >= 0 ||
                                                        admin.rolelist.indexOf(ROLE.Bulk_Nach_Status_Update) >= 0 ||
                                                        admin.rolelist.indexOf(ROLE.Approved_To_Disbursed_Disbursed_By_ICICI) >= 0) && (
                                                            <>
                                                                <li className='mail-list' style={{ marginTop: '15px' }} onClick={(e) => this.subHandleTab(e, 'bulkOps', 'lms')}>
                                                                    <AccountTreeIcon /> &nbsp; Bulk Operations
                                                                    {this.state.lmsSubTab ?
                                                                        <i className="fa fa-caret-up" aria-hidden="true" style={{ float: 'right', color: '#000' }}></i>
                                                                        : <i className="fa fa-caret-down" aria-hidden="true" style={{ float: 'right', color: '#000' }}></i>}
                                                                </li>
                                                                {this.state.lmsSubTab && (
                                                                    <>
                                                                       
                                                                        {admin.rolelist.indexOf(ROLE.Initiate_Bulk_Payment) >= 0 && (
                                                                            <li style={{ marginTop: '10px', marginLeft: '15px' }} onClick={(e) => pageViewHandler(e, 'bulkPayByRazorPay')}>
                                                                                <CircleIcon style={{ color: 'grey', width: '10px', marginBottom: '-1px' }} /><span style={{ color: 'grey' }}> Initiate Bulk Payment By CSV</span>
                                                                            </li>
                                                                        )}
                                                                        {admin.rolelist.indexOf(ROLE.Bulk_Paid) >= 0 && (
                                                                            <li style={{ marginTop: '10px', marginLeft: '15px' }} onClick={(e) => pageViewHandler(e, 'covertToPaid')}>
                                                                                <CircleIcon style={{ color: 'grey', width: '10px', marginBottom: '-1px' }} /><span style={{ color: 'grey' }}> Convert to Paid</span>
                                                                            </li>
                                                                        )}
                                                                      

                                                                        {admin.rolelist.indexOf(ROLE.Approved_To_Disbursed_Disbursed_By_ICICI) >= 0 && (
                                                                            <li style={{ marginTop: '10px', marginLeft: '15px' }} onClick={(e) => pageViewHandler(e, 'ApprovedLeads')}>
                                                                                <CircleIcon style={{ color: 'grey', width: '10px', marginBottom: '-1px' }} /><span style={{ color: 'grey' }}> Approved Leads</span>
                                                                            </li>
                                                                        )}
                                                                        {admin.rolelist.indexOf(ROLE.Approved_To_Disbursed_Disbursed_By_ICICI) >= 0 && (
                                                                            <li style={{ marginTop: '10px', marginLeft: '15px' }} onClick={(e) => pageViewHandler(e, 'icici')}>
                                                                                <CircleIcon style={{ color: 'grey', width: '10px', marginBottom: '-1px' }} /><span style={{ color: 'grey' }}> Disburse By ICICI</span>
                                                                            </li>
                                                                        )}
                                                                        {admin.rolelist.indexOf(ROLE.Approved_To_Disbursed_Disbursed_By_ICICI) >= 0 && (
                                                                            <li style={{ marginTop: '10px', marginLeft: '15px' }} onClick={(e) => pageViewHandler(e, 'approveToDisburse')}>
                                                                                <CircleIcon style={{ color: 'grey', width: '10px', marginBottom: '-1px' }} /><span style={{ color: 'grey' }}> Approved to Disburse By CSV</span>
                                                                            </li>
                                                                        )}
                                                                      
                                                                    </>
                                                                )}
                                                            </>
                                                        )}

                                                </>

                                            </ul>
                                        </div>
                                    </div>

                                    : "" : ""}
                          
                           

                            {admin.rolelist != undefined && admin.rolelist.length > 0 && (admin.rolelist.indexOf(ROLE.ROLE_ASSIGN) >= 0 || admin.rolelist.indexOf(ROLE.LM_Assignment_Rule) >= 0 || admin.rolelist.indexOf(ROLE.Manual_Lead_Assignment) >= 0 || admin.rolelist.indexOf(ROLE.NBFC_CONFIGURATION) >= 0 || admin.rolelist.indexOf(ROLE.EXECUTOR_ROLE) >= 0 || admin.rolelist.indexOf(ROLE.ALL_PRODUCTS) >= 0 || admin.rolelist.indexOf(ROLE.API_TRACKER) >= 0 || admin.rolelist.indexOf(ROLE.ALL_POLICY) >= 0) ?

                                <div className='col-sm-3 col-xs-12'>
                                    <div className='landing-cards' style={{ marginBottom: '30px' }}>
                                        <div className='landing-head' style={{ background: '#fff6ee', borderTopLeftRadius: '5px', borderTopRightRadius: '5px' }}><img style={{ width: '24px' }} src={AccessmanagementLogo} />&nbsp;Access Management</div>
                                        <div className='landing-inner'>

                                            {admin.rolelist != undefined && admin.rolelist.length > 0 ? admin.rolelist.indexOf(ROLE.ROLE_ASSIGN) >= 0 ?
                                                <div style={{ marginTop: '15px', cursor: 'pointer' }}

                                                    onClick={(e) => pageViewHandler(e, 'Roleassign')}
                                                >
                                                    <ViewStreamIcon style={{ width: '13px', marginBottom: '-1px' }} /> &nbsp;  Admin Roles
                                                </div>
                                                : "" : ""}
                                            {admin.rolelist != undefined && admin.rolelist.length > 0 ?
                                                admin.rolelist.indexOf(ROLE.LM_Assignment_Rule) >= 0 || admin.rolelist.indexOf(ROLE.Manual_Lead_Assignment) >= 0 ?
                                                    <div style={{ marginTop: '15px', cursor: 'pointer' }}

                                                        onClick={(e) => pageViewHandler(e, 'Bulkassign')}
                                                    >
                                                        <ViewStreamIcon style={{ width: '13px', marginBottom: '-1px' }} /> &nbsp;  Application Assignment
                                                    </div>
                                                    : "" : ""}

                                            <div style={{ marginTop: '15px', cursor: 'pointer' }}

                                                onClick={(e) => pageViewHandler(e, 'nbfcDashboard')}
                                            >
                                                <ViewStreamIcon style={{ width: '13px', marginBottom: '-1px' }} /> &nbsp;  NBFC Management
                                            </div>

                                            {admin.rolelist.indexOf(ROLE.NBFC_CONFIGURATION) >= 0 ?
                                                <>
                                                    <div className='mail-list'>
                                                        <div
                                                            style={{ marginTop: '15px' }}
                                                            onClick={() => this.nbfcTabsHandle()}>
                                                            <AccountTreeIcon /> &nbsp; NBFC {this.state.nbfcTabs ? <i className="fa fa-caret-up" aria-hidden="true" style={{ float: 'right', color: '#000' }}></i> : <i className="fa fa-caret-down" aria-hidden="true" style={{ float: 'right', color: '#000' }}></i>}
                                                        </div>
                                                    </div>
                                                    {this.state.nbfcTabs ?
                                                        <>
                                                            {admin.rolelist != undefined && admin.rolelist.length > 0 ?
                                                                admin.rolelist.indexOf(ROLE.Add_Nbfc) >= 0 ?
                                                                    <div style={{ marginTop: '10px', marginLeft: '15px' }}
                                                                        onClick={(e) => pageViewHandler(e, 'addNbfcNew')}
                                                                    >
                                                                        <CircleIcon style={{ color: 'grey', width: '10px', marginBottom: '-1px' }} /><span style={{ color: 'grey' }}>Add NBFC</span>
                                                                    </div>
                                                                    : "" : ""}
                                                            {admin.rolelist != undefined && admin.rolelist.length > 0 ?
                                                                admin.rolelist.indexOf(ROLE.Add_Nbfc) >= 0 ?
                                                                    <div style={{ marginTop: '10px', marginLeft: '15px' }}
                                                                        onClick={(e) => pageViewHandler(e, 'nbfcConfig')}
                                                                    >
                                                                        <CircleIcon style={{ color: 'grey', width: '10px', marginBottom: '-1px' }} /><span style={{ color: 'grey' }}>  NBFC Config</span>
                                                                    </div>
                                                                    : "" : ""}
                                                            {admin.rolelist != undefined && admin.rolelist.length > 0 ?
                                                                admin.rolelist.indexOf(ROLE.Add_Nbfc) >= 0 ?
                                                                    <div style={{ marginTop: '10px', marginLeft: '15px' }}
                                                                        onClick={(e) => pageViewHandler(e, 'allnbfclead')}
                                                                    >
                                                                        <CircleIcon style={{ color: 'grey', width: '10px', marginBottom: '-1px' }} /><span style={{ color: 'grey' }}> All NBFC</span>
                                                                    </div>
                                                                    : "" : ""}

                                                           

                                                        </>
                                                        : ""}
                                                </>
                                                : ""}

                                            {admin.rolelist != undefined ?
                                                (admin.rolelist.indexOf(ROLE.EXECUTOR_ROLE) >= 0) ?
                                                    <>
                                                        <div className='mail-list' style={{ marginTop: '15px' }} onClick={(e) => this.subHandleTech(e)}>
                                                            <AccountTreeIcon /> &nbsp; Tech & Products
                                                            {this.state.policyTabTech ?
                                                                <i className="fa fa-caret-up" aria-hidden="true" style={{ float: 'right', color: '#000' }}></i>
                                                                : <i className="fa fa-caret-down" aria-hidden="true" style={{ float: 'right', color: '#000' }}></i>}
                                                        </div>
                                                        {this.state.policyTabTech && (
                                                            <>
                                                                {admin.rolelist != undefined ?
                                                                    admin.rolelist.indexOf(ROLE.EXECUTOR_ROLE) >= 0 ?
                                                                        <div style={{ marginTop: '10px', marginLeft: '15px' }} onClick={(e) => pageViewHandler(e, 'Executor')}>
                                                                            <CircleIcon style={{ color: 'grey', width: '10px', marginBottom: '-1px' }} /><span style={{ color: 'grey' }}>Executor Configuration</span>
                                                                        </div>
                                                                        : "" : ""}
                                                                {admin.rolelist.indexOf(ROLE.API_TRACKER) >= 0 ?
                                                                    <div style={{ marginTop: '10px', marginLeft: '15px' }} onClick={(e) => pageViewHandler(e, 'apiconfig')}>
                                                                        <CircleIcon style={{ color: 'grey', width: '10px', marginBottom: '-1px' }} /><span style={{ color: 'grey' }}> API Tracker</span>
                                                                    </div>
                                                                    : ""}




                                                            </>
                                                        )}
                                                    </>
                                                    : "" : ""}
                                            {admin.rolelist != undefined ?
                                                (admin.rolelist.indexOf(ROLE.API_TRACKER) >= 0 || admin.rolelist.indexOf(ROLE.ALL_PRODUCTS) >= 0) ?
                                                    <>
                                                        <div className='mail-list' style={{ marginTop: '15px' }} onClick={(e) => this.subHandleTechLending(e)}>
                                                            <AccountTreeIcon /> &nbsp; Lending Products
                                                            {this.state.lendingProduct ?
                                                                <i className="fa fa-caret-up" aria-hidden="true" style={{ float: 'right', color: '#000' }}></i>
                                                                : <i className="fa fa-caret-down" aria-hidden="true" style={{ float: 'right', color: '#000' }}></i>}
                                                        </div>
                                                        {this.state.lendingProduct && (
                                                            <>



                                                                {admin.emailId && admin.emailId === 'SuperUser' ?
                                                                    <div style={{ marginTop: '10px', marginLeft: '15px' }} onClick={(e) => pageViewHandler(e, 'kycHandle')}>
                                                                        <CircleIcon style={{ color: 'grey', width: '10px', marginBottom: '-1px' }} /><span style={{ color: 'grey' }}> Kyc Start Stop</span>
                                                                    </div>

                                                                    : ""}
                                                            
                                                               
                                                                {admin.rolelist != undefined ?
                                                                    admin.rolelist.indexOf(ROLE.ALL_PRODUCTS) >= 0 ?
                                                                        < div style={{ marginTop: '10px', marginLeft: '15px' }} onClick={(e) => pageViewHandler(e, 'LoanUtility')}>
                                                                            <CircleIcon style={{ color: 'grey', width: '10px', marginBottom: '-1px' }} /><span style={{ color: 'grey' }}>  Business Loan</span>
                                                                        </div>
                                                                        : "" : ""}
                                                            </>
                                                        )}
                                                    </>
                                                    : "" : ""}
                                            {admin.rolelist != undefined ?
                                                admin.rolelist.indexOf(ROLE.ALL_POLICY) >= 0 ?
                                                    <>
                                                        <div className='mail-list' style={{ marginTop: '15px' }} onClick={(e) => this.subHandleTabPolicy(e)}>
                                                            <AccountTreeIcon /> &nbsp; Policy
                                                            {this.state.policyTab ?
                                                                <i className="fa fa-caret-up" aria-hidden="true" style={{ float: 'right', color: '#000' }}></i>
                                                                : <i className="fa fa-caret-down" aria-hidden="true" style={{ float: 'right', color: '#000' }}></i>}
                                                        </div>
                                                        {this.state.policyTab && (
                                                            <>
                                                                {admin.rolelist != undefined ?
                                                                    admin.rolelist.indexOf(ROLE.ALL_POLICY) >= 0 ?
                                                                        <div style={{ marginTop: '10px', marginLeft: '15px' }} onClick={(e) => pageViewHandler(e, 'allPolicy')}>
                                                                            <CircleIcon style={{ color: 'grey', width: '10px', marginBottom: '-1px' }} /><span style={{ color: 'grey' }}>  Credit Policy</span>
                                                                        </div>
                                                                        : "" : ""}
                                                                {admin.rolelist != undefined ?
                                                                    admin.rolelist.indexOf(ROLE.ALL_POLICY) >= 0 ?
                                                                        <div style={{ marginTop: '10px', marginLeft: '15px' }} onClick={(e) => pageViewHandler(e, 'scoringConfig')}>
                                                                            <CircleIcon style={{ color: 'grey', width: '10px', marginBottom: '-1px' }} /><span style={{ color: 'grey' }}>  Scoring Config</span>
                                                                        </div>
                                                                        : "" : ""}
                                                               



                                                            </>
                                                        )}
                                                    </>
                                                    : "" : ""}

                                            {admin.rolelist != undefined ?
                                                admin.rolelist.indexOf(ROLE.COMMUNICATION_FLOW) >= 0 ?
                                                    <div style={{ marginTop: '15px', cursor: 'pointer' }}
                                                        onClick={e => pageViewHandler(e, 'communicationFlow')}
                                                    >
                                                        <ViewStreamIcon style={{ width: '13px', marginBottom: '-1px' }} /> &nbsp;Communication Flow
                                                    </div>
                                                    : "" : ""}

                                                     {admin.rolelist != undefined ?
                                                    <div style={{ marginTop: '15px', cursor: 'pointer' }}
                                                        onClick={e => pageViewHandler(e, 'documentConfigBL')}
                                                    >
                                                        <ViewStreamIcon style={{ width: '13px', marginBottom: '-1px' }} /> &nbsp;Document Configurations
                                                    </div>
                                                    : ""}




                                        </div>

                                    </div>
                                </div>
                                : ""}
                            {admin.rolelist != undefined ? (admin.rolelist.indexOf(ROLE.Dashboard) >= 0 || admin.rolelist.indexOf(ROLE.Incoming_Payment_Report) >= 0 || admin.rolelist.indexOf(ROLE.DASHBOARD_REPORT_NEW) >= 0 || admin.rolelist.indexOf(ROLE.Generate_Report_Logs) >= 0 || admin.rolelist.indexOf(ROLE.INCOME_COLLECTED) >= 0 || admin.rolelist.indexOf(ROLE.Check_FlipKart_Balance) >= 0) ?
                                <div className='col-sm-3 col-xs-12'>
                                    <div className='landing-cards' style={{ marginBottom: '30px' }}>
                                        <div className='landing-head' style={{ background: '#f0e7ff', borderTopLeftRadius: '5px', borderTopRightRadius: '5px' }}><img style={{ width: '24px' }} src={DashboardLogo} />&nbsp;Dashboard & Reports</div>
                                        <div className='landing-inner'>
                                           
                                            {admin.emailId == "SuperUser" ?
                                                <div style={{ marginTop: '15px', cursor: 'pointer' }}

                                                    onClick={e => pageViewHandler(e, 'dashboardNewTesting')}
                                                >
                                                    <ViewStreamIcon style={{ width: '13px', marginBottom: '-1px' }} /> &nbsp; Dashboard
                                                </div>
                                                : ""}
                                            {admin.rolelist != undefined ?
                                                admin.rolelist.indexOf(ROLE.Incoming_Payment_Report) >= 0 ?
                                                    <div style={{ marginTop: '15px', cursor: 'pointer' }}
                                                        onClick={e => pageViewHandler(e, 'IncomingPaymentReport')}
                                                    >
                                                        <ViewStreamIcon style={{ width: '13px', marginBottom: '-1px' }} /> &nbsp;  Incoming Payment Report
                                                    </div>
                                                    : "" : ""}
                                            {admin.rolelist != undefined ?
                                                admin.rolelist.indexOf(ROLE.DASHBOARD_REPORT_NEW) >= 0 ?
                                                    this.state.generateReportState == true ?
                                                        <div style={{ marginTop: '15px', cursor: 'pointer' }}
                                                            onClick={e => pageViewHandler(e, 'reportGenerateNew')}
                                                        >
                                                            <ViewStreamIcon style={{ width: '13px', marginBottom: '-1px' }} /> &nbsp;  Generate Report
                                                        </div>
                                                        : ""
                                                    : "" : ""}
                                                     {admin.rolelist != undefined && admin.rolelist.length > 0 ?
                                                    admin.rolelist.indexOf(ROLE.RAZORPAY_REPORT) >= 0 ?
                                                        <div
                                                            style={{ marginTop: '15px' }}
                                                            onClick={(e) => pageViewHandler(e, 'razorpay')}
                                                        >
                                                            <ViewStreamIcon style={{ width: '13px', marginBottom: '-1px' }} /> &nbsp; Payment Gateway Report
                                                        </div>
                                                        : "" : ""}
                                            {
                                                admin.rolelist != undefined ?
                                                    admin.rolelist.indexOf(ROLE.CIC_REPORT) >= 0 ?
                                                        <div style={{ marginTop: '15px', cursor: 'pointer' }}
                                                            onClick={e => pageViewHandler(e, 'cicdReport')}
                                                        >
                                                            <ViewStreamIcon style={{ width: '13px', marginBottom: '-1px' }} /> &nbsp;  CIC Report
                                                        </div>
                                                        : "" : ""}
                                            {admin.rolelist != undefined ?
                                                admin.rolelist.indexOf(ROLE.Generate_Report_Logs) >= 0 ?

                                                    <div style={{ marginTop: '15px', cursor: 'pointer' }}

                                                        onClick={e => pageViewHandler(e, 'GenReportLogs')}
                                                    >
                                                        <ViewStreamIcon style={{ width: '13px', marginBottom: '-1px' }} /> &nbsp;  Generate Report Logs
                                                    </div>
                                                    : "" : ""}

                                            

                                            <div style={{ marginTop: '15px', cursor: 'pointer' }}

                                                onClick={e => pageViewHandler(e, 'automationLogs')}
                                            >
                                                <ViewStreamIcon style={{ width: '13px', marginBottom: '-1px' }} /> &nbsp; Automation Logs
                                            </div>
                                            

                                        </div>

                                    </div>
                                </div>
                                : "" : ""}
                          
                            {admin.rolelist != undefined && admin.rolelist.length > 0 ?
                                (admin.rolelist.indexOf(ROLE.COLLECTION_SECTION) >= 0) ?
                                    <div className='col-sm-3 col-xs-12' >
                                        <div className='landing-cards' style={{ marginBottom: '30px' }}>
                                            <div className='landing-head' style={{ background: '#ffe7e8', borderTopLeftRadius: '5px', borderTopRightRadius: '5px' }}><img style={{ width: '24px' }} src={FinanceLogo} />&nbsp;Collection & Payments</div>
                                            <div className='landing-inner'>
                                                
                                                {admin.rolelist != undefined ?
                                                    admin.rolelist.indexOf(ROLE.ALL_PAYMENTS) >= 0 ?
                                                        <>
                                                            <div
                                                                style={{ marginTop: '15px' }}
                                                                onClick={(e) => pageViewHandler(e, 'paymentMain')}
                                                            >
                                                                <ViewStreamIcon style={{ width: '13px', marginBottom: '-1px' }} /> &nbsp; Payments
                                                            </div>

                                                        </>
                                                        : "" : ""}

                                                {

                                                    admin.rolelist.indexOf(ROLE.NPA_DASHBOARD) >= 0 ?
                                                        <div
                                                            style={{ marginTop: '15px' }}
                                                            onClick={(e) => pageViewHandler(e, 'NPADashboard')}
                                                        >
                                                            <ViewStreamIcon style={{ width: '13px', marginBottom: '-1px' }} /> &nbsp; NPA Dashboard
                                                        </div>
                                                        : ''}

                                            </div>
                                        </div>

                                    </div>
                                    : "" : ""}
                         
                            {admin.rolelist != undefined && admin.rolelist.length > 0  ?
                                (admin.rolelist.indexOf(ROLE.STL_SECTION) >= 0) ?
                                    <div className='col-sm-3 col-xs-12' >
                                        <div className='landing-cards' style={{ marginBottom: '30px' }}>
                                            <div className='landing-head' style={{ background: '#61c6bdc4', borderTopLeftRadius: '5px', borderTopRightRadius: '5px' }}><img style={{ width: '24px' }} src={electricCar} />&nbsp;SVL</div>
                                            <div className='landing-inner'>





                                                <div style={{ marginTop: '15px' }}
                                                    onClick={(e) => pageViewHandler(e, 'SvlLoanApplications')}
                                                >
                                                    <ViewStreamIcon style={{ width: '13px', marginBottom: '-1px' }} /> &nbsp; SV Loan Application
                                                </div>
                                                <div style={{ marginTop: '15px' }}
                                                    onClick={(e) => pageViewHandler(e, 'SvlApplications')}
                                                >
                                                    <ViewStreamIcon style={{ width: '13px', marginBottom: '-1px' }} /> &nbsp; SV Application
                                                </div>




                                            </div>
                                        </div>

                                    </div>
                                    : "" : ""}

                                     {admin.rolelist != undefined && admin.rolelist.length > 0  ?
                                (admin.rolelist.indexOf(ROLE.STL_DISBURSE) >= 0) ?
                                    <div className='col-sm-3 col-xs-12' >
                                        <div className='landing-cards' style={{ marginBottom: '30px' }}>
                                            <div className='landing-head' style={{ background: '#fffcce', borderTopLeftRadius: '5px', borderTopRightRadius: '5px' }}><img style={{ width: '24px' }} src={LmsLogo} />&nbsp;SVL LMS</div>
                                            <div className='landing-inner'>


                                                <div
                                                    style={{ marginTop: '15px' }}
                                                    onClick={(e) => pageViewHandler(e, 'SvlApprovedLeads')}
                                                >
                                                    <ViewStreamIcon style={{ width: '13px', marginBottom: '-1px' }} /> &nbsp; Approved Leads

                                                </div>
                                                <div
                                                    style={{ marginTop: '15px' }}
                                                    onClick={(e) => pageViewHandler(e, 'SvlDisburseByIcici')}
                                                >
                                                    <ViewStreamIcon style={{ width: '13px', marginBottom: '-1px' }} /> &nbsp;Disburse By ICICI
                                                </div>





                                            </div>
                                        </div>

                                    </div>
                                    : "" : ""}



                        </div>



                    </div >
                    : ""
                }
            </>
        )
    }
}
const mapStateToProps = ({ admin, tenant }) => {
    return {
        tenant: tenant.activeTenant
        // admin: admin,
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({

    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Landingpage);